import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SearchCityPageComponent } from '@smatchy/components/pages/logged/pages/home/pages/search-page/pages/search-city-page/search-city-page.component';

@Injectable({
  providedIn: 'root',
})
export class ModalManagerAdapter {
  private activeModals: Map<string, HTMLIonModalElement> = new Map();

  constructor(private readonly modalController: ModalController) {}

  async openSearchCityModal(options?: {
    rayon?: number;
    formattedAddress?: string;
    country?: string;
    city?: string;
    region?: string;
    lat?: number;
    lng?: number;
    returnToModal?: string;
    groupId?: string;
    groupName?: string;
  }): Promise<HTMLIonModalElement> {
    const modalId = 'search-city-modal';
    
    const existingModal = this.activeModals.get(modalId);
    if (existingModal) {
      await existingModal.present();
      return existingModal;
    }

    const topModal = await this.modalController.getTop();
    const modal = await this.modalController.create({
      component: SearchCityPageComponent,
      componentProps: {
        ...options,
      },
      presentingElement: topModal || undefined,
      breakpoints: [0, 1],
      initialBreakpoint: 1,
    });

    this.activeModals.set(modalId, modal);
    
    modal.onDidDismiss().then(() => {
      this.activeModals.delete(modalId);
    });

    await modal.present();
    return modal;
  }

  async closeSearchCityModal(): Promise<void> {
    const modalId = 'search-city-modal';
    const modal = this.activeModals.get(modalId);
    if (modal) {
      await modal.dismiss();
      this.activeModals.delete(modalId);
    }
  }

  async closeAllModals(): Promise<void> {
    for (const [id, modal] of this.activeModals.entries()) {
      await modal.dismiss();
    }
    this.activeModals.clear();
  }
}

